import endOfWeek from 'date-fns/endOfWeek';
import startOfWeek from 'date-fns/startOfWeek';
import isValid from 'date-fns/isValid';
import getDay from 'date-fns/getDay';

/**
 * The getWeekStartOn calculates the day number that the week starts on
 * date: The date that was selected/hovered, can be null
 * weekStartsOn: the day number we want to start the week with, can be 'flexible'
 *               in case 'flexible' we return the day number of the selected date
 */
const getWeekStartOn = ({ date, weekStartsOn = 0, }) => {
    if (weekStartsOn === 'flexible') {
        return date ? getDay(date) : 0;
    }
    return weekStartsOn;
};
const getWeekDetails = (date, weekStartsOn) => {
    let start = null;
    let end = null;
    if (date && isValid(date)) {
        start = startOfWeek(date, { weekStartsOn: getWeekStartOn({ date, weekStartsOn }) });
        end = endOfWeek(date, { weekStartsOn: getWeekStartOn({ date, weekStartsOn }) });
    }
    return { start, end };
};

export { getWeekDetails, getWeekStartOn };
//# sourceMappingURL=getWeekDetails.js.map
